// A title page wears its game's colours (the brief, "Art direction"): the cover's top colour as the accent when it
// reads against the page (3:1), else the shell's ruby; the bottom colour as the wash. Pure.

import type { Game } from "../../catalogue.ts";
import { contrast } from "../spec.ts";
import { PAGE_BG, SHELL_ACCENT } from "./template.ts";

const HEX = /^#[0-9a-f]{6}$/i;

/** Lighten "#rrggbb" towards white by `t` (0–1). */
function lighten(hex: string, t: number): string {
  const c = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).map((v) => Math.round(v + (255 - v) * t));
  return `#${c.map((v) => v.toString(16).padStart(2, "0")).join("")}`;
}

/** The page accent: the game's top colour, lifted until it reads on the page (3:1), else the shell's ruby. */
export function accentFor(palette: Pick<Game["palette"], "top"> | null | undefined): string {
  const top = palette?.top;
  if (!top || !HEX.test(top)) return SHELL_ACCENT;
  for (let t = 0; t <= 0.6; t += 0.1) {
    const c = t === 0 ? top.toLowerCase() : lighten(top, t);
    if (contrast(c, PAGE_BG) >= 3) return c;
  }
  return SHELL_ACCENT;
}

/** The wash colour behind the top of the page: the cover's bottom colour, else the page itself. */
export function washFor(palette: Pick<Game["palette"], "bottom"> | null | undefined): string {
  const b = palette?.bottom;
  return b && HEX.test(b) ? b.toLowerCase() : PAGE_BG;
}
